import Modal from "./Modal";
import React from "react";
import ContentApi from "../../api/ContentApi";
import EntityApi from "../../api/EntityApi";


type ModalAjaxProps = {
    id: number,
    onClose: () => void,
    isOpen?: boolean,
}
const ModalAjax = ({id, onClose, isOpen}:ModalAjaxProps) =>{

    const [title, setTitle] = React.useState('');
    const [text, setText] = React.useState('');
    const [isLoad, setIsLoad] = React.useState(false);
    const [isFullScreen, setFullScreen] = React.useState(false);

    React.useEffect(() => {
        if (isOpen && !isLoad) {
            setFullScreen(false);
            EntityApi.get('private/material-content', id).then((data) => {
                if (data.content.item) {
                    setTitle(data.content.item.title);
                    setText(data.content.item.text);
                    if (data.content.item.type === 'pdf') {
                        setFullScreen(true);
                    } else {
                        setFullScreen(false);
                    }
                    //setIsLoad(true);
                }
            });
        }
    }, [isOpen])

    const onCloseThis = () => {
        setTitle('');
        setText('');
        onClose();
    }

    return <Modal title={title} text={text} isOpen={isOpen} isFullScreen={isFullScreen} onClose={onCloseThis}/>
}

export default ModalAjax;
